import { VITE_BASE_URL } from "@/env/client";

const CONTACT_EMAIL_DOMAIN = new URL(VITE_BASE_URL).hostname.replace(/^www\./, "");

export const SUPPORT_EMAIL = `support@${CONTACT_EMAIL_DOMAIN}`;
export const SALES_EMAIL = `sales@${CONTACT_EMAIL_DOMAIN}`;
